import { Tooltip } from '@material-ui/core';
import CachedIcon from '@material-ui/icons/Cached';
import format from 'date-fns/format';
import React, { useEffect, useState } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import moment from 'moment';
import CallEndIcon from '@material-ui/icons/CallEnd';
import Loading from '../../../components/Loading';
import { useMessageBox } from '../../../context/MessageBox';
import api from '../../../services/api';
import { convertForRealFormatted } from '../../../utils/convertForRealFormatted';
import { convertNumberPercent } from '../../../utils/convertNumberPercent';
import { handleErrorRequest } from '../../../utils/errorsValidation';
import { padLeadingZeros } from '../../../utils/padLeadingZeros';
import * as S from './styles';

const NO_DATA_MESSAGE =
  'Sucessso na execução da solicitação, porém, não existe retorno com os parâmetro(s) solicitado(s).';

function HistoryTable({
  provider,
  anchorId,
  statusPropose,
  setUpdateInfo,
  reloadPage,
  providerInfo,
  setAtualizaAbatimentoDesconto,
  atualizarAbatimentoDesconto,
  maxHeight
}) {
  const { setMessageData } = useMessageBox();
  const [isLoading, setIsLoading] = useState(false);
  const [history, setHistory] = useState([]);



  const columns = [
    {
      text: 'Pagto',
      dataField: 'destinoPagamento',
      sort: true,
      formatter: (cell, rowData) => {
        return (
          <span
            className="text-left-block"
            style={{ cursor: 'pointer' }}
            onClick={() => {
              rowData.fornecedorId = providerInfo.fornecedorId;
              reloadPage(rowData, 'HistoricoConsultaPesquisa');
              setUpdateInfo({
                origin: 'notas-disponiveis',
                id: rowData.antecipacaoId,
                canUpdate: false,
              });
            }}
          >
            {cell}
          </span>
        );
      },
    },
    {
      text: 'Data Pagamento',
      dataField: 'dataPagamento',
      sort: true,
      formatter: (cell, rowData) => {
        return (
          <span
            className="text-center-block"
            style={{ cursor: 'pointer' }}
            onClick={() => {
              rowData.fornecedorId = providerInfo.fornecedorId;
              reloadPage(rowData, 'HistoricoConsultaPesquisa');
              setUpdateInfo({
                origin: 'notas-disponiveis',
                id: rowData.antecipacaoId,
                canUpdate: false,
              });
            }}
          >
            {format(new Date(cell), 'dd/MM/yy')}
          </span>
        );
      },
    },
    {
      text: 'Prz',
      dataField: 'prazoMedio',
      sort: true,
      formatter: (cell, rowData) => {
        return (
          <span
            className="text-right-block"
            style={{ cursor: 'pointer' }}
            onClick={() => {
              rowData.fornecedorId = providerInfo.fornecedorId;
              reloadPage(rowData, 'HistoricoConsultaPesquisa');
              setUpdateInfo({
                origin: 'notas-disponiveis',
                id: rowData.antecipacaoId,
                canUpdate: false,
              });
            }}
          >
            {padLeadingZeros(cell, 0)}
          </span>
        );
      },
    },
    {
      text: 'Taxa',
      dataField: 'taxa',
      sort: true,
      formatter: (cell, rowData) => (
        <span
          className="text-right-block"
          style={{ cursor: 'pointer' }}
          onClick={() => {
            rowData.fornecedorId = providerInfo.fornecedorId;
            reloadPage(rowData, 'HistoricoConsultaPesquisa');
            setUpdateInfo({
              origin: 'notas-disponiveis',
              id: rowData.antecipacaoId,
              canUpdate: false,
            });
          }}
        >
          {convertNumberPercent(cell?.toFixed(2), 2)}
        </span>
      ),
    },
    {
      text: 'Deságio',
      dataField: 'desagio',
      sort: true,
      formatter: (cell, rowData) => {
        return (
          <span
            className="text-right-block"
            style={{ cursor: 'pointer' }}
            onClick={() => {
              rowData.fornecedorId = providerInfo.fornecedorId;
              reloadPage(rowData, 'HistoricoConsultaPesquisa');
              setUpdateInfo({
                origin: 'notas-disponiveis',
                id: rowData.antecipacaoId,
                canUpdate: false,
              });
            }}
          >
            {convertNumberPercent(cell?.toFixed(2), 2)}
          </span>
        );
      },
    },
    {
      text: 'Valor NF',
      dataField: 'valorBruto',
      sort: true,
      formatter: (cell, rowData) => {
        return (
          <span
            className="text-right-block"
            style={{ cursor: 'pointer' }}
            onClick={() => {
              rowData.fornecedorId = providerInfo.fornecedorId;
              reloadPage(rowData, 'HistoricoConsultaPesquisa');
              setUpdateInfo({
                origin: 'notas-disponiveis',
                id: rowData.antecipacaoId,
                canUpdate: false,
              });
            }}
          >
            {convertForRealFormatted(cell, 2)}
          </span>
        );
      },
    },
    {
      text: 'Valor Antec.',
      dataField: 'valorLiquido',
      sort: true,
      formatter: (cell, rowData) => (
        <span
          className="text-right-block"
          style={{ cursor: 'pointer' }}
          onClick={() => {
            rowData.fornecedorId = providerInfo.fornecedorId;
            reloadPage(rowData, 'HistoricoConsultaPesquisa');
            setUpdateInfo({
              origin: 'notas-disponiveis',
              id: rowData.antecipacaoId,
              canUpdate: false,
            });
          }}
        >
          {convertForRealFormatted(cell, 2)}
        </span>
      ),
    },
    {
      text: 'Receita',
      dataField: 'valorDesconto',
      sort: true,
      formatter: (cell, rowData) => (
        <span
          className="text-right-block"
          style={{ cursor: 'pointer' }}
          onClick={() => {
            rowData.fornecedorId = providerInfo.fornecedorId;
            reloadPage(rowData, 'HistoricoConsultaPesquisa');
            setUpdateInfo({
              origin: 'notas-disponiveis',
              id: rowData.antecipacaoId,
              canUpdate: false,
            });
          }}
        >
          {convertForRealFormatted(cell, 2)}
        </span>
      ),
    },
    {
      text: 'Cto',
      dataField: 'contatoEfetuado',
      sort: true,
      formatter: (cell, rowData) => {
        return (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer'  }}>
            {cell ? (
              <Tooltip placement="top" title={moment(cell).format('DD/MM/YYYY HH:mm')}>
                  <CallEndIcon style={{fontSize: 20 ,color: '#232c63',}} />
              </Tooltip>
            ) : ''}
          </div>
        );
      },
    },
    {
      text: 'Selecionado',
      dataField: 'condicao',
      sort: true,
      formatter: (cell, rowData) => {
        return (
          <span className={`${rowData.status === 'Aprovada' ? 'has-status' : ''}`}>
            <span
              className="text-left-block"
              style={{ cursor: 'pointer' }}
              onClick={() => {
                rowData.fornecedorId = providerInfo.fornecedorId;
                reloadPage(rowData, 'HistoricoConsultaPesquisa');
                setUpdateInfo({
                  origin: 'notas-disponiveis',
                  id: rowData.antecipacaoId,
                  canUpdate: false,
                });
              }}
            >
              {cell === 'Nenhum' ? '' : cell}
            </span>
          </span>
        );
      },
    },
    // {
    //   text: 'Status',
    //   dataField: 'status',
    //   hidden: false,
    //   sort: true,
    //   onSort: (field, order) => reprintColorTable(),
    //   formatter: (cell, rowData) => {
    //     return (
    //       <span className={`${rowData.status === 'Aprovada' ? 'has-status' : ''}`}>
    //         {rowData.status}
    //       </span>
    //     );
    //   },
    // },
  ];

  const fetchHistory = async () => {
    setIsLoading(true);
    try {
      const response = await api.get(
        `OperacoesAntecipacoes/ConsultarHistorico?ancoraId=${anchorId}&fornecedorId=${
          provider?.fornecedorId || provider?.[0]?.fornecedorId
        }`,
      );
      if (response.data.status !== 'Inconsistencia') {
        if (response.data.resposta[0].message !== NO_DATA_MESSAGE) {
          setHistory(response.data.resposta);
          setMessageData(response?.data?.complemento?.mensagensBox);
        } else {
          setHistory([]);
          setMessageData(response?.data?.complemento?.mensagensBox);
        }
      } else {
        handleErrorRequest(response);
      }
    } catch (error) {
      handleErrorRequest(error.response);
    } finally {
      setAtualizaAbatimentoDesconto(false)
    }
    setIsLoading(false);
  };

  useEffect(() => {
    if (provider) {
      fetchHistory();
    }
  }, [provider]);

  useEffect(() => {
    if (provider && atualizarAbatimentoDesconto) {
      fetchHistory();
    }
  }, [atualizarAbatimentoDesconto]);

  if ((!provider && !isLoading) || statusPropose) {
    return (
      <S.TableTitleHeader>
        <h3 className="operation-title">Histórico</h3>
      </S.TableTitleHeader>
    );
  }

  if (isLoading) {
    return (
      <>
        <S.TableTitleHeader>
          <h3 className="operation-title">Histórico</h3>
        </S.TableTitleHeader>
        <Loading />
      </>
    );
  }

  if (provider && !isLoading) {
    setTimeout(() => {
      const elements = document.getElementsByClassName('historico-status-Aprovada');
      if (elements) {
        for (const item of elements) {
          item.closest('tr').style.backgroundColor = '#b3e5fc';
        }
      }
    }, 100);
  }

  const rowStyle = (row) => {
    const style = {}

    if(row.corFonte) {
      style.color = row.corFonte
    }

    if (row.corFundo) {
      style.backgroundColor = row.corFundo
    }

    return style
  }

  return (
    <S.TableContent>
      <S.TableTitleHeader>
        <h3 className="operation-title">Histórico</h3>
        <Tooltip placement="top" title="Recarregar conteúdo">
          <CachedIcon className="pointer" onClick={() => fetchHistory()} />
        </Tooltip>
      </S.TableTitleHeader>
      {history && (
        <S.HeightTableContainer maxHeight={maxHeight}>
          <BootstrapTable columns={columns} data={history} keyField="id" striped hover condensed rowStyle={rowStyle}/>
        </S.HeightTableContainer>
      )}
    </S.TableContent>
  );
}

export default HistoryTable;
